import React, { useContext } from 'react';
import {
  SectionFilterTool,
  FinderBar,
  Bar,
  FindOpt,
  FormGroup,
  ViewIcons,
  VIconList,
  VIconGrid,
  ShowHide,
} from './styles/PressFilterBlock.styled';
import { Button } from './styles/Button.styled';
import ListIcon from './ListIcon';
import GridIcon from './GridIcon';
import { Container } from './styles/Container.styled';
import LatestNewsContext from '../context/LatestNewsContext';
import LatestNewsPaginatedSelect from './LatestNewsPaginatedSelect';

export default function LatestNewsPaginatedFilterBar({ dir }) {
  const { listing, setListing, displayMenu, setDisplayMenu, setOption, yearsOptions, option } =
    useContext(LatestNewsContext);

  const handleClick = () => setDisplayMenu(() => !displayMenu);

  const filterByText = dir === 'ltr' ? 'Filter By' : 'التصفية حسب';
  const filterText = dir === 'ltr' ? 'Filter' : 'التصفية';
  const mostRecentText = dir === 'ltr' ? 'Most Recent' : 'مؤخرا';

  return (
    <SectionFilterTool id="latestNewsPaginatedFilterBar">
      <FinderBar>
        <Container>
          <Bar>
            <ShowHide onClick={handleClick} dir={dir}>
              {mostRecentText}
            </ShowHide>
            <FindOpt clicked={displayMenu}>
              <FormGroup>
                <label htmlFor="date_sort" dir={dir}>
                  {filterByText}
                </label>
              </FormGroup>
              <FormGroup className="press_select_button">
                <LatestNewsPaginatedSelect
                  dir={dir}
                  onChange={setOption}
                  options={yearsOptions}
                  selected={option}
                />
              </FormGroup>
              <FormGroup className="filter_button">
                <Button stylevariant="secondary" target="_self" rel="" dir={dir}>
                  {filterText}
                </Button>
              </FormGroup>
            </FindOpt>
            <ViewIcons dir={dir} className="latestnews_gridview">
              <VIconList>
                <ListIcon
                  selected={listing === 'listpress'}
                  setValue={setListing}
                  type="latestNews"
                />
                <span className="sr-only">List View</span>
              </VIconList>
              <VIconGrid className={listing === 'grid' ? 'active' : ''}>
                <GridIcon selected={listing === 'grid'} setValue={setListing} type="latestNews" />
                <span className="sr-only">Grid View</span>
              </VIconGrid>
            </ViewIcons>
          </Bar>
        </Container>
      </FinderBar>
    </SectionFilterTool>
  );
}
